import { extendReplicantConfigForAnalytics } from '@play-co/gcinstant/replicantExtensions';
import { createConfig } from '@play-co/replicant';

import { stateSchema, State } from './State';
import messages from './config/messages';
import actions from './config/actions';
import migrator from './migrations/migrator';
import computedProperties from './config/computedProperties';
import scheduledActions from './config/scheduledActions';
import asyncGetters from './config/asyncGetters';
import eventHandlers from './config/eventHandlers';
import chatbot from './chatbot';
import ab from './ruleset/ab';
import { encodeReplicantMessagePayload } from './payloads';
import adminTool from './admin/admin.tools';
import { sharedStates } from './sharedState';
import { extendReplicantConfigForDebugPanel } from '@play-co/debug-panel/replicant';
import { iapComponentModule as IAPComponent } from './iap/component/iap.module';

const VERSION = process.env.APP_VERSION;
const appName = process.env.APP_NAME && process.env.APP_NAME.replace(/'/g, '');

export const config = createConfig({
  stateSchema,
  ruleset: { abTests: ab.dynamicAB },
  messages,
  scheduledActions,
  actions,
  asyncGetters,
  migrator,
  chatbot,
  encodePlatformMessagePayload: encodeReplicantMessagePayload,
  computedProperties,
  onLoginAction: 'onLogin',
  appName,
  version: VERSION,
  adminTool,
  sharedStates,
  eventHandlers,
  modules: [IAPComponent],
  enableBackgroundActionScheduling: true,
  enableBackgroundServerAnalyticsTracking: true,
  enableLineAccessTokenAuthentication: true,
  enableLineUserTokenFallback: false, // TODO: Dissable this when https://buruburu.app/ will redirect to miniapp without auth. This defaults to false. Remove it when we are sure it's not needed. See: https://github.com/play-co/buruburu/pull/9968
});

export default extendReplicantConfigForDebugPanel(
  extendReplicantConfigForAnalytics(config, {
    amplitudeTimeZone: 'Asia/Tokyo',
    getPlatformStorage: (state: State) => state.platformStorage,
  }),
);
